import usePanelColors from "../../utils/usePanelColors";
import React, { useContext, useEffect, useState } from "react";
import { Box, Tab, Tabs, Typography } from "@material-ui/core";
import MainContainer from "../../components/MainContainer";
import { AuthContext } from "../../context/Auth/AuthContext";
import { hasPermission } from "../../utils/userPermissions";
import usePlans from "../../hooks/usePlans";
import QueueIntegration from "../QueueIntegration";
import ConnectionSettings from "./ConnectionSettings";
export default function IntegrationsHub() {
  const colors=usePanelColors();
  const { user } = useContext(AuthContext);
  const [tab, setTab] = useState(0);
  const [otherEnabled, setOtherEnabled] = useState(false);
  const { getPlanCompany } = usePlans();
  useEffect(() => {
    let active = true;
    getPlanCompany(undefined, user.companyId).then(data => { if (active) setOtherEnabled(Boolean(data?.plan?.useIntegrations)); }).catch(() => {});
    return () => { active = false; };
  }, [user.companyId]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!hasPermission(user, "integrations")) return <MainContainer><Typography>Acesso não permitido.</Typography></MainContainer>;
  return <MainContainer><Box className={colors.root} p={2} style={{flex:1,minHeight:0,overflowY:"auto"}}>
    <Typography component="h1" variant="h5">Integrações</Typography>
    <Typography color="textSecondary" style={{marginTop:6}}>Gerencie as conexões dos serviços, as solicitações de contratação e os destinatários de e-mail da empresa.</Typography>
    <Tabs value={tab} onChange={(_,value)=>setTab(value)} indicatorColor="primary" textColor="primary" variant="scrollable" scrollButtons="auto" style={{marginTop:16}}>
      <Tab label="Conexões"/><Tab label="E-mail e cadastros"/>{otherEnabled && <Tab label="Outras integrações"/>}
    </Tabs>
    <Box mt={3}>{tab < 2 ? <ConnectionSettings key={user.companyId} section={tab}/> : <QueueIntegration embedded/>}</Box>
  </Box></MainContainer>;
}
